import axios from "axios";
import CssBaseline from "@material-ui/core/CssBaseline/CssBaseline";
import React, { Component } from "react";
import createPalette from "@material-ui/core/styles/createPalette";

import { connect } from "react-redux";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { MuiThemeProvider } from "@material-ui/core/styles";

import {
  CyContainer,
  AdvisorInvitation,
  CprTest,
  DEV,
  ForgotPasswordContainer,
  LoginContainer,
  ResetPasswordContainer,
  SummaryPDF,
} from "./containers";

import { appAction, userAction } from "./actions";

import { AppTheme, updateChartColors } from "./theme";
import "./App.scss";
import { CyPalette } from "./utilities/palette";
import { Head } from "./components/UI/Head";


// axios defaults
axios.defaults.withCredentials = true;
axios.defaults.headers.common['x-wbicy-tenant-origin'] = window.location.origin;
const searchParams = new URLSearchParams(window.location.search);
if (searchParams.has('tenantId')) {
  axios.defaults.headers.common['x-wbicy-tenant-id'] = searchParams.get('tenantId');
}

const AuthRoute = ({
  component: Component,
  authenticating,
  loggedIn,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      loggedIn || authenticating ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);

class App extends Component {
  componentDidMount() {
    this.props.dispatch(userAction.loadUserApplicationState());
    this.props.dispatch(appAction.loadUiConfigs());
    this.props.dispatch(appAction.getCustomConfiguration());
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (!this.props.user.loggedIn && nextProps.user.loggedIn) {
      this.props.dispatch(appAction.loadUiConfigs());
      this.props.dispatch(userAction.loadUserApplicationState());
      this.props.dispatch(appAction.getCustomConfiguration());
    }
  }

  render() {
    const { user, app: { palette } } = this.props;
    let theme = AppTheme;
  
    if (palette != null) {
      const customPallet = CyPalette.getCustomPalette(this.props.app.palette);
      updateChartColors({
        C1: customPallet.primary.main,
        C2: customPallet.secondary.main
      });
      theme = {
        ...AppTheme,
        palette: createPalette(customPallet)
      }
    }

    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Head />
        <IntlProvider locale="en">
          <BrowserRouter>
            <Switch>
              <Route path="/(login|signup)" component={LoginContainer} />
              <Route
                path="/forgot-password"
                component={ForgotPasswordContainer}
              />
              <Route
                path="/reset-password"
                component={ResetPasswordContainer}
              />
              <Route path="/summary-pdf/" component={SummaryPDF} />
              <Route path="/invite" component={AdvisorInvitation} />
              <AuthRoute
                path="/Portal"
                component={CyContainer}
                loggedIn={user.loggedIn}
                authenticating={user.readingUser}
              />
              <Route exact path={`/dev`} component={DEV} />
              <Route path="/cpr-test/" component={CprTest} />
              <Redirect to="/login" />
            </Switch>
          </BrowserRouter>
        </IntlProvider>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    app: state.app,
    user: state.user,
  };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.jsx